import React, { useState } from 'react';
import { Row, Col, Container } from 'reactstrap';
import ContactMap from './ContactMap';
import ContactForm from './ContactForm';
import ContactInfoCards from './ContactInfoCards';

const GetInTouch = () => {
  return (
    <Container>
      <div className="contact-us-section">
        <div data-aos="fade-up">
          <h2>
            Get in <span>Touch</span>
          </h2>
          <p className="head-gap-lg">
            We're here to guide you with trusted solutions tailored to your needs.
          </p>
        </div>

        <div className="contact-container" data-aos="fade-up">
          <div className="contact-info-cards">
            <ContactInfoCards />
          </div>
          <Row>
            <Col lg="6" sm="12" data-aos="fade-right" data-aos-delay="400" data-aos-duration="1500">
              <ContactMap />
            </Col>
            <Col lg="6" sm="12" data-aos="fade-left" data-aos-delay="400" data-aos-duration="1500">
              <ContactForm />
            </Col>
          </Row>
        </div>
      </div>
    </Container>
  );
};

export default GetInTouch;
